import { styled } from '@linaria/react';
import theme from '@clad-ui/theme';
const {
  radii
} = theme;
const typeIconClass = "tfp9az8";

/* limit description to 2 lines */
const lineLimitClass = "l1o326jf";
const ChildrenWrapper = /*#__PURE__*/styled('div')({
  name: "ChildrenWrapper",
  class: "chyvzm6",
  propsAsIs: false
});
const StyledAnnouncer = /*#__PURE__*/styled('div')({
  name: "StyledAnnouncer",
  class: "s1qcsk11",
  propsAsIs: false
});
const ExpandButton = /*#__PURE__*/styled('button')({
  name: "ExpandButton",
  class: "e1k3dz7z",
  propsAsIs: false
});
const ActionButton = /*#__PURE__*/styled('button')({
  name: "ActionButton",
  class: "awb3b7l",
  propsAsIs: false
});
const CloseButton = /*#__PURE__*/styled('button')({
  name: "CloseButton",
  class: "cetl4u7",
  propsAsIs: false
});
const _exp64 = /*#__PURE__*/() => ({
  width
}) => width;
const _exp65 = /*#__PURE__*/() => ({
  height
}) => height;
const _exp66 = /*#__PURE__*/() => ({
  radius
}) => radius || radii.sm;
const _exp68 = /*#__PURE__*/() => ({
  margin
}) => margin || 0;
const Skeleton = /*#__PURE__*/styled('div')({
  name: "Skeleton",
  class: "sx6pyva",
  propsAsIs: false,
  vars: {
    "sx6pyva-0": [_exp64()],
    "sx6pyva-1": [_exp65()],
    "sx6pyva-2": [_exp66()],
    "sx6pyva-3": [_exp68()]
  }
});
const SkeletonWrapper = /*#__PURE__*/styled('div')({
  name: "SkeletonWrapper",
  class: "sgwy8yc",
  propsAsIs: false
});
export { typeIconClass, StyledAnnouncer, lineLimitClass, ExpandButton, ActionButton, CloseButton, ChildrenWrapper, Skeleton, SkeletonWrapper };

require("./Announcer.styles.linaria.module.css");